import { useEffect } from 'react';
import { RequestStatus } from '../interface';
import { selectAccountsDataState, selectFilteredAccounts } from '../selectors/accounts-data.selectors';
import { selectPortalId } from '../selectors/portal.selectors';
import { getAccountsDataThunk } from '../thunks/accounts-data.thunk';
import { useAppDispatch, useAppSelector } from './index';
const useAccountsData = () => {
  const portalId = useAppSelector(selectPortalId);
  const dispatch = useAppDispatch();
  const {
    status
  } = useAppSelector(selectAccountsDataState);
  const accounts = useAppSelector(selectFilteredAccounts);
  useEffect(() => {
    if (status !== RequestStatus.IDLE) {
      return;
    }
    void dispatch(getAccountsDataThunk(portalId));
  }, [dispatch, portalId, status]);
  return accounts;
};
export default useAccountsData;